<script>
import { required, minLength, numeric } from "vuelidate/lib/validators";
import General from "@/services/General";
import Customers from "@/services/Customers";
import validationMessages from "@/components/validations";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  props: ["positions"],
  components: {
    validationMessages,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      csrf_token: localStorage.getItem("csrf_token"),
      image_url: "",
      position: "",
      availablePositions: [],
      photoDeletedCompanyImage: false,
      photoDeletedLogoUrl: false,
      submitted: false,
      imageUrlDeleted: false,
      showModal: false,
      tryingToSubmit: false,
      verified_checked: true,
      maxCharsDescription: 65500,
      maxCharsName: 128,
      external_companies: null,
      select_external_company: "",
      loading:true,

      dropzoneOptions_primary: {
        url: "/",
        autoProcessQueue: false,
        addRemoveLinks: true,
        thumbnailWidth: 200,
        thumbnailMethod: "contain",
        maxFilesize: 10, // MB
        acceptedFiles: "image/jpeg,image/png,image/jpg",
        maxFiles: 1,
        uploadMultiple: false,
      },
    };
  },
  validations: {
    image_url: {
      required,
    },
    position: {
      required,
    },
  },
  methods: {
    
    async fetchAvailableMediaPositions() {
          try {
              this.loading = true;
              const response = await General.getApplicationMediaAvailablePositions()
              this.availablePositions = response?.data?.data || []
              this.loading = false;
          } catch (error) {
              this.availablePositions = []
              console.log(error);
              this.loading = false;
          }
      },
    async addImage() {
      this.tryingToSubmit = true;
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.tryingToSubmit = false;
        return;
      } else {
        try {
          const formData = new FormData();
          formData.append("image_url", this.image_url);
          formData.append("position", this.position);
          await General.addApplicationMedia(formData)
            .then((response) => {
              this.successmsg("Changes have been saved");
              this.refreshData();
              this.closeModal();
            })
            .catch((error) => {
              this.error = error.response.data.error
                ? error.response.data.error
                : "";
              this.failedmsg(this.error);
            })
            .finally(() => {
              this.tryingToSubmit = false;
            });
        } catch (error) {
          this.error = error.response.data.error
            ? error.response.data.error
            : "";
          this.failedmsg(this.error);
        }
      }
      this.tryingToSubmit = false;
    },

    selectFileImageUrl(files) {
      setTimeout(() => {
        if (files.length > 1) {
          this.failedmsg("You can only have one image");
          files.forEach((value) => {
            this.$refs.myVueDropzone_logo_url.removeFile(value);
          });
        }
        if (files[0] && files[0].accepted) {
          this.image_url = files[0];
          this.imageUrlDeleted = false;
        }
      }, 250);
    },

    fileError(file, message) {
      this.$refs.myVueDropzone_logo_url.removeFile(file);
      this.failedmsg(message);
    },
    refreshData() {
      this.$emit("onRefresh");
    },
    closeModal() {
      if (this.$refs.myVueDropzone_logo_url) {
        this.$refs.myVueDropzone_logo_url.removeAllFiles(true);
      }
      this.showModal = false;
      this.resetProps();
    },
     syncData() {
         this.fetchAvailableMediaPositions()
    },
    resetProps() {
      this.image_url = "";
      this.position = "";
      this.submitted = false;
    },
  },
};
</script>

<template>
  <b-modal
    v-model="showModal"
    @hidden="resetProps"
    @shown="syncData"
    id="add_application_media_image"
    size="lg"
    hide-footer
    centered
  >
    <template v-slot:modal-header class="application-media-modal">
      <div class="w-100">
        <h2>Upload an Appliaction Media Image</h2>
      </div>
      <button
        type="button"
        class="btn-close"
        @click="closeModal"
        aria-label="Close"
      ></button>
    </template>

    <form @submit.prevent="addImage" class="application-media__hero">
      <div v-if="!loading">
        <div class="application-media-card">
            <header class="application-media-card__header">
                <h3>Image Position</h3>
                <p>Choose where the image will appear</p>
          </header>

          <b-form-select
            id="position"
            v-model="position"
            :options="availablePositions"
          ></b-form-select>

          <validationMessages
            v-if="submitted"
            :fieldName="'Position'"
            :validationName="$v.position"
          ></validationMessages>

        </div>

        <section class=" application-media-card">
          <header class="application-media-card__header application-media-card__header--icon">
            <i class="uil uil-image"></i>
            <div>
              <h3>Application Media Image</h3>
            </div>
          </header>
          
          <div class="application-image-upload">
            <vue-dropzone
              id="image_url"
              ref="myVueDropzone_logo_url"
              :use-custom-slot="true"
              :options="dropzoneOptions_primary"
              @vdropzone-files-added="selectFileImageUrl"
              @vdropzone-error="fileError"
              no-progress-bar
            >
              <div class="dropzone-custom-content">
                <i class="uil uil-import"></i>
                <span>Drag and drop an image, or click to browse</span>
                <small>PNG, JPG up to 5MB</small>
              </div>
            </vue-dropzone>
          </div>
          <validationMessages
            v-if="submitted"
            :fieldName="'Image'"
            :validationName="$v.image_url"
          ></validationMessages>
        </section>
      </div>
      <div class="d-flex align-items-center justify-content-center" v-else>
         <b-spinner large />
      </div>
      <input type="hidden" name="csrf_token" v-model="csrf_token" />

          <footer class="application-media-modal__footer">
          <b-button variant="outline-secondary" @click="closeModal">Cancel</b-button>
          <b-button variant="dark" type="submit" :disabled="tryingToSubmit">
            <b-spinner v-if="tryingToSubmit" small class="me-2" />
            Upload Image
          </b-button>
        </footer>
    </form>
     <!-- footer is hidden -->
    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button
        v-if="availablePositions.length"
        variant="primary"
        @click="addImage"
        :disabled="tryingToSubmit"
      >
        <b-spinner v-show="tryingToSubmit" small></b-spinner>
        Submit</b-button
      >
    </template>
  </b-modal>
</template>

<style>
.application-media-modal {
  padding: 32px;
  background: #f7f8fb;
}

.application-media-card {
    background: #ffffff;
    border-radius: 16px;
    padding: 28px;
    margin-bottom: 24px;
    box-shadow: 0 12px 32px rgb(15 23 42 / 6%);
}

.application-media-card__header{
      margin-bottom: 24px;
}
.application-media-card__header h2{
      font-size:35px;
}
.application-media__hero{
      margin-bottom: 24px;
}

.application-media__hero h2 {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 8px;
  color: #151a2d;
}

.application-media__hero p {
  margin: 0;
  color: #5f6b7d;
  font-size: 16px;
}
.application-media-card__header h3 {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 600;
  color: #151a2d;
}



.application-media-card__header p {
  margin: 0;
  color: #5f6b7d;
}

.application-media-card__header--icon{
    display: flex;
    align-items: center;
    gap: 16px;
}
.application-media-card__header--icon i {
  font-size: 32px;
  color: #151a2d;
  line-height: 1;
}
.dropzone-custom-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #5f6b7d;
  font-size: 14px;
  text-align: center;
}

.dropzone-custom-content i {
  font-size: 32px;
  color: #151a2d;
}

.dropzone-custom-content small {
  color: #a0aec0;
}

.application-image-upload {
  border: 2px dashed #d3d8e6;
  border-radius: 16px;
  background: #f7f8fb;
  padding: 32px;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.application-media-modal__footer{
    display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
}
#image_url {
  display: flex;
  align-items: center;
  justify-content: center;
}
#image_url .dz-preview .dz-image {
  width: 100% !important;
}

@media (max-width: 767.98px) {
  .application-media-modal {
    padding: 20px;
  }

  .application-media-card {
    padding: 20px;
  }
}
</style>
